const BAHAMAS_TZ = "America/Nassau";

export const formatBahamasDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleDateString("en-CA", {
    timeZone: BAHAMAS_TZ,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

export const formatBahamasDateTime = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  const dateLabel = date.toLocaleDateString("en-US", {
    timeZone: BAHAMAS_TZ,
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
  const timeLabel = date.toLocaleTimeString("en-US", {
    timeZone: BAHAMAS_TZ,
    hour: "2-digit",
    minute: "2-digit",
  });
  return `${dateLabel} ${timeLabel}`;
};

/** Prefer lifecycle API fields; fall back for older records with null dates. */
export const getSubmissionDate = (app) =>
  app?.submissionDate || app?.submitted_at || app?.created_at || null;

export const getApprovalDate = (app) =>
  app?.approvalDate || app?.approved_at || app?.issue_date || app?.updated_at || null;

export const getRejectionDate = (app) =>
  app?.rejectionDate || app?.rejected_at || app?.updated_at || null;

export const formatDateParam = (date) => {
  if (!date) return null;
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return null;
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};
